import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class EntitiesRequestParams extends BaseApiRequestParams {
  competitions: Array<Number>;
  competitors: Array<Number>;
  athletes: Array<Number>;
  games: Array<Number>;
  withSeasons: Boolean;

  constructor( competitions: Array<Number> = [], competitors: Array<Number> = [], games: Array<Number>, athletes: Array<Number> = [], withSeasons: Boolean = false) {
    super('entities/');

    this.competitions = competitions;
    this.competitors = competitors;
    this.athletes = athletes;
    this.games = games;
    this.withSeasons = withSeasons;
  }

  equals(model: EntitiesRequestParams): Boolean {
    let equal = super.equals(model);

    equal &= JSON.stringify(this.competitions) === JSON.stringify(model.competitions);
    equal &= JSON.stringify(this.competitors) === JSON.stringify(model.competitors);
    equal &= JSON.stringify(this.athletes) === JSON.stringify(model.athletes);
    equal &= JSON.stringify(this.games) === JSON.stringify(model.games);
    equal &= this.withSeasons === model.withSeasons;

    return equal;

  }
}
